import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Image, Icon, Header, Label, Sidebar, Button, Table, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import { DataGrid } from '../../common';
import SideEditor from '../../general/SideEditor';
import {
    fetchLoyaltyProgramRestaurants,
    removeRestaurantFromLoyaltyProgram,
    setEditedEntity,
    confirmDelete
} from '../../../actions';
import LoyaltyProgramRestaurantsEditor from './LoyaltyProgramRestaurantsEditor';

class LoyaltyProgramRestaurants extends Component {

    constructor(props) {
        super(props);

        this.handleRestaurantRemoval = this.handleRestaurantRemoval.bind(this);
        this.renderCreationButton = this.renderCreationButton.bind(this);
    }

    componentWillMount() {
        const { loyaltyProgram, fetchLoyaltyProgramRestaurants } = this.props;
        if (loyaltyProgram && loyaltyProgram.restaurantsIds) {
            const lpRestaurants = loyaltyProgram.name === 'Paidit' ? null : loyaltyProgram.restaurantsIds;
            fetchLoyaltyProgramRestaurants(loyaltyProgram.id, lpRestaurants);
        }
    }

    handleRestaurantRemoval(restaurant) {
        const { confirmDelete, removeRestaurantFromLoyaltyProgram, loyaltyProgram } = this.props;
        confirmDelete(restaurant.name, () => removeRestaurantFromLoyaltyProgram(loyaltyProgram.id, restaurant.id));
    }

    renderCreationButton() {
        const { setEditedEntity } = this.props;

        return (
            <Button
                icon
                labelPosition='left'
                primary
                onClick={() => setEditedEntity('loyaltyProgramRestaurant')}
                floated='right'
            >
                <Icon name='add' /> {i18next.t('create')}
            </Button>
        );
    }

    render() {
        const { loyaltyProgram, restaurants, onEdit, setEditedEntity } = this.props;

        if (!loyaltyProgram || !restaurants) return null;

        const columns = [{
            Header: '#',
            maxWidth: 50,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' },
            accessor: 'id'
        }, {
            Header: i18next.t('name'),
            accessor: 'name',
            filterable: true
        }, {
            Header: i18next.t('address'),
            accessor: 'address',
            filterable: true
        }, {
            id: 'actions',
            Header: i18next.t('actions'),
            maxWidth: 120,
            sortable: false,
            filterable: false,
            Cell: row => {
                const rest = row.original;
                return (
                    <div>
                        <Button circular size='tiny' icon='trash' negative onClick={() => this.handleRestaurantRemoval(rest)} />
                    </div>
                );
            }
        }];

        return (
            <div style={{ padding: 10 }}>
                <SideEditor
                    title={i18next.t('restaurant')}
                    visible={onEdit}
                    handleClose={() => setEditedEntity(null)}
                >
                    <LoyaltyProgramRestaurantsEditor loyaltyProgramId={loyaltyProgram.id} />
                </SideEditor>
                <DataGrid
                    data={restaurants}
                    columns={columns}
                    getTrGroupProps={(state, rowInfo, column) => {
                        if (typeof rowInfo !== "undefined" && rowInfo.original && rowInfo.original.unregistered) {
                            return { className: 'pi-data-grid-row-negative' };
                        }
                        return {};
                    }}
                    extraActions={this.renderCreationButton()}
                    paginated
                   
                />
            </div>
        );
    }
}

LoyaltyProgramRestaurants.propTypes = {
    fetchLoyaltyProgramRestaurants: PropTypes.func,
    removeRestaurantFromLoyaltyProgram: PropTypes.func,
    loyaltyProgram: PropTypes.object,
    restaurants: PropTypes.array,
    onEdit: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    confirmDelete: PropTypes.func,
    
};

function mapStateToProps(state) {
    const { restaurants } = state.loyaltyApp;
    const onEdit = state.editor.type === 'loyaltyProgramRestaurant';

    return { restaurants, onEdit };
}
export default connect(mapStateToProps, {
    fetchLoyaltyProgramRestaurants,
    removeRestaurantFromLoyaltyProgram,
    confirmDelete,
    setEditedEntity,
})(LoyaltyProgramRestaurants);
